export const types = {
	addTodo: 'Agregar-Todo',
	deleteTodo: 'Eliminar-Todo',
	editTodo: 'Editar-Todo',
}
